<template>
    <div class="container-fluid" v-if="school">
        
        <div class="card shadow my-4">
            <div class="card-header py-3">
                <div class="btn-group" role="group">
                    <button type="button" class="btn" v-bind:class="[type==null || type==undefined || type==2 ? 'btn-primary' : 'btn-default']" @click="type=2;_getData()">Ахлах</button>
                    <button type="button" class="btn" v-bind:class="[type && type==1 ? 'btn-primary' : 'btn-default']" @click="type=1;_getData()">Дунд</button>
                    <button type="button" class="btn" v-bind:class="[type==0 ? 'btn-primary' : 'btn-default']"  @click="type=0;_getData()">Бага</button>
                </div>
            </div>
            <div class="card-body">
                <div >
                    <div  class="row " v-if="categories && categories.length>0">
                        <div style="cursor:pointer;font-size:16px;" class="my-2 badge p-2 mr-2" @click="selectedCategories=[];"  v-bind:class="[!selectedCategories || (selectedCategories && selectedCategories.length==0) ? 'badge-success' : 'badge-light']">Бүгд</div>
                        <div style="cursor:pointer;font-size:16px;" class="my-2 badge p-2 mr-2" @click="toggleDepartmentFilter(category, selectedCategories, 'id', false, 100)" v-for="category in categories" v-bind:class="[isInDepartmentFilter(category, selectedCategories, 'id')==true ? 'badge-success' : 'badge-light']">{{category.name}}</div>

                    </div>
                    
                </div>

                <div class="table-responsive mt-3" >
                    <table id="crossword" class="table table-sm table-bordered" width="100%" cellspacing="0">
                        <thead>
                            <tr>
                                <th width="15%" class="bottom-border border-top" rowspan="2">Хичээл</th>
                                <th width="15%" class="bottom-border border-top left-border" rowspan="2">Багш</th>
                                <th class="left-border bottom-border border-top" v-for="department in departments" v-bind:colspan="department.programs.length">
                                    {{department.index}}
                                </th>
                            </tr>
                            <tr>
                                <th class="bottom-border border-top" v-bind:class="classObject(program,  null)" v-for="program in programs">
                                    {{program.name}}
                                </th>
                            </tr>
                        </thead>
                        <tbody v-for="(category, cindex) in categories" v-if="(!selectedCategories) || (selectedCategories && selectedCategories.length==0) || (selectedCategories && selectedCategories.length>0 && isInDepartmentFilter(category, selectedCategories, 'id')==true ) ">
                            <tr v-for="(lesson, index) in category.teachers" @click="selectedTeacher=lesson;openSubContentModal()" v-if="category.teachers && category.teachers.length>0" >
                                <td class="bg-warning text-dark font-weight-bold" v-if="index==0" v-bind:rowspan="category.teachers.length">{{cindex+1}}.
                                    <span >{{category.name}}</span>
                                    
                                </td>
                      
 
                                <td class="left-border" >
                                    <span v-if="lesson.lastName">{{lesson.lastName[0]}}.</span>
                                    {{lesson.firstName}}
                                    <span v-if="lesson.lessons" class="text-primary">
                                        /{{lesson.lessons.length}}/
                                    </span>
                                </td>
                                <td v-for="program in programs" v-bind:class="classObject(program, lesson)">
                                    

                                </td>

                        
                            </tr>
                            <tr rowspan="5" v-else>
                                <td>Одоогоор мэдээлэл ороогүй байна.</td>
                            </tr>
                        
                        </tbody>
                    </table>
                </div>
   

            </div>
        </div>

        <div class="modal fade" id="submodal" tabindex="-1" role="dialog" aria-labelledby="submodalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                    
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="selectedTeacher">
                        <div class="table-responsive" v-if="selectedTeacher.lessons!=null && selectedTeacher.lessons.length>0">
                            <table class="table table-bordered" id="dataTable" width="100%" cellspacing="0">
                                <thead>
                                    <tr>
                                        <th>№</th>
                                        <th>Нэр</th>
                                        <th>Анги</th>
                                        <th>Багш</th>
                                        <th>Үйлдэл</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr v-for="(lesson, index) in selectedTeacher.lessons" v-bind:key="lesson.id">
                                        <td>{{index+1}}</td>
                                        <td>
                                            {{lesson.name}}
                                            <span class="text-primary" v-if="lesson.classNos && lesson.classNos.length>0">  /{{lesson.classNos[0]}} анги/</span>
                                        </td>
                                        <td>
                                            <ul v-if="lesson.groups && lesson.groups.length>0">
                                                <li style="cursor:pointer" v-for="group in lesson.groups" @click="$router.push({ name: 'IGroupStudents', params: { schoolId: schoolId, departmentId: group.department.id, programId: group.program.id} })">
                                                    <span v-if="group.departmentName">{{group.departmentName}}</span>
                                                    <span v-else>-</span>
                                                    /
                                                    <span v-if="group.programName">{{group.programName}}</span>
                                                    <span v-else>-</span>
                                                </li>
                                            </ul>
                                        </td>
                                        <td>
                                            <div style="cursor:pointer" v-if="lesson.teachers && lesson.teachers.length>0"  @click="$router.push({ name:'TeacherLessons', params:{schoolId:schoolId, teacherPath: lesson.teachers[0].reference.path} })">
                                                <span v-if="lesson.teachers">
                                                    {{lesson.teachers[0].firstName}}
                                                </span>

                                                <span v-if="lesson.teachers">
                                                    / {{lesson.teachers[0].lastName}}
                                                </span>
                                            </div>
                                        </td>
                           

                                        <td>
                                            <button data-dismiss="modal" class="btn btn-primary btn-sm mr-2" @click="$router.push({ name:'SLessonDetail', params:{ schoolId: schoolId, lessonId: lesson.id } })">харах</button>
                                            <button data-dismiss="modal" class="btn btn-warning btn-sm" @click="$router.push({ name: 'ILessonEdit', params: { lessonId: lesson.id, schoolId: schoolId, setTeacher:true} })">засах</button>
                                        </td>
                                    </tr>
                                
                                </tbody>
                            </table>
         
                            </div>
                            <div v-else class="alert alert-info text-center">Одоогоор мэдээлэл ороогүй байна.</div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Хаах</button>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="loading==true" style="position:fixed;z-index:10000000; top:45%;left:45%">
            <div class="spinner-grow text-primary" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <div class="spinner-grow text-secondary" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <div class="spinner-grow text-success" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <div class="spinner-grow text-danger" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <div class="spinner-grow text-warning" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <div class="spinner-grow text-info" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <div class="spinner-grow text-dark" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>

    </div>
    
</template>

<script>
    import { mapState } from 'vuex'
    import moment from 'moment'
    const fb = require('../../../firebaseConfig.js')

    export default {
        data() {
            return {
               teachers:[],
               lastVisible:null,
               loading:false,
               last:false,
               showSimple:true,
               searchValue:null,
               searched:false,
               searchField:'email',
               pageSize:30,
               school:null,
               departments:[],
               selectedDepartments:[],
               categories:[],
               selectedCategories:[],
               department:null,
               category:null,
               programs:[],
               selectedTeacher:null,
               type:null,
               loading:false

            }
        },
        props: {
            schoolId: { 
                required: true,
            },
            departmentId:{
                required:false
            },
            categoryId:{
                required:false
            }
        },
        computed: {
            ...mapState(['userProfile', 'currentUser']),
        },
        methods: {
            classObject (val, lesson) {

                return {
                    'left-border': val.first==true,
                    'right-border':val.last==true,
                    'bg-success': lesson && lesson.lessons && this.programInLesson(lesson.lessons, val) ,
                }
                
            },

            async _getData(){
                
                var schoolDoc=await fb.db.doc('schools/'+this.schoolId).get();
                if(schoolDoc.exists){
                    let school=schoolDoc.data();
                    school.id=schoolDoc.id;
                    school.ref=schoolDoc.ref;
                    this.school=school;
                    this.categories=[];
                    this.teachers=[];
                    this.programs=[];
                    this.departments=[];
                    this.selectedTeacher=null;
                    this.selectedCategories=[];
                    this.selectedDepartmens=[];
                    var list=[];
                    if(this.type==0){
                        list=[1,2,3,4,5];
                    }
                    else if(this.type==1){
                        list=[6,7,8,9];
                    }
                    else{
                        list=[10,11,12];
                    }
                    this.loading=true;
                    var depSnapshot=await schoolDoc.ref.collection("departments").where("index", "in", list).get();
                    if(depSnapshot && !depSnapshot.empty){
                        this.selectedDepartments=[];
                        this.teachers=[];

                        for(const depDoc of depSnapshot.docs){
                            if(depDoc.exists){
                                let department=depDoc.data();
                                department.id=depDoc.id;
                                department.ref=depDoc.ref;
                                department.programs=[];
                                var proSnapshot=await depDoc.ref.collection("programs").orderBy('name').get();
                                if(proSnapshot && !proSnapshot.empty){
                                    var index=0;
                                    var tmpPros=[];
                                    for(const proDoc of proSnapshot.docs){
                                        let program=proDoc.data();
                                        program.id=proDoc.id;
                                        program.ref=proDoc.ref;
                                        if(index==0){
                                            program.first=true;
                                        }
                                        if(index==proSnapshot.docs.length){
                                            program.last=true;
                                        }
                                        tmpPros.push(program);
                                        // this.programs.push(program);
                                        index++;
                                    }
                                    if(tmpPros && tmpPros.length>0){
                                        tmpPros.sort(function(a, b) {
                                            return a.name == b.name ? 0 : +(a.name > b.name) || -1;
                                        });
                                        department.programs=tmpPros;
                                    }
                                }
                                this.department=department;
                                this.departments.push(department);
                                if(department && department.index){
                                    this.selectedDepartments.push(department.index);
                                }
                            }
                        }
                        
                        this.departments.sort(function(a, b) {
                            return a.index == b.index ? 0 : +(a.index > b.index) || -1;
                        });

                        for(const ddd of this.departments){
                            if(ddd && ddd.programs){
                                for(const ppp of ddd.programs){
                                    this.programs.push(ppp);
                                }
                            }
                        }
                    }

                    var categorySnapshot= await schoolDoc.ref.collection("categories").orderBy("index").get();
                    if(categorySnapshot && !categorySnapshot.empty){
                        for(const categoryDoc of categorySnapshot.docs){
                            let category=categoryDoc.data();
                            category.id=categoryDoc.id;
                            category.ref=categoryDoc.ref;
                            category.lessons=[];
                            category.teachers=[];
                            this.categories.push(category);
                        }

                        await this.getLessonsData();
                    }
                    this.loading=false;

                    // var categoryDoc= await schoolDoc.ref.collection("categories").doc(this.categoryId).get();
                    // let category=categoryDoc.data();
                    // category.id=categoryDoc.id;
                    // category.ref=categoryDoc.ref;
                    // category.lessons=[];
                    // this.category=category;
                    // this.categories.push(category);

                    // await this.getLessonsData();

                }

                
            },
    
            async getLessonsData(){

                // if(this.last==false){
                    this.loading=true;
                    var query;
                    query=fb.db.collection("schools/"+this.schoolId+"/lessons");
                    
                    if(this.searchValue && this.searchValue!='' && this.searchValue.length>2){
                       query=query.where("searchTags", "array-contains", this.searchValue); 
                    }
                    else{
                        if(this.selectedDepartments && this.selectedDepartments.length>0){
                            console.log(this.selectedDepartments.length);
                            query=query.where("classNos", "array-contains-any", this.selectedDepartments);
                        }
                    }
                    // if(this.sele)
                    // query=query.orderBy("createdAt", "desc");

                    if(query!=null){
                        var documentSnapshots=await query.get();
                        this.lastVisible= documentSnapshots.docs[documentSnapshots.docs.length-1];
                        for(const doc of documentSnapshots.docs){
                            let object=doc.data()
                            object.id = doc.id;
                            object.procent=0;
                  
                            if(object.category && object.category.id){
                                for(const category of this.categories){
                                    if(category && category.id && category.id==object.category.id){
                                        // category.lessons.push(object);
                                        await this.addTeacher(object, category);
                                        break;
                                    }
                                }
                                this.teachers.push(object);
                            }
                            
                        }
                   
                        // if(documentSnapshots.size!=this.pageSize)
                        //     this.last=true;
                    }
                    this.loading=false;
                // }
               
            },

            search(){
                this.lastVisible=null;
                this.last=false;
                this.teachers=[];
                for(const category of this.categories){
                    category.lessons=[];
                        
                }

                this.getLessonsData();
    
                
            },
            async searchBy(value){
                if(this.searchField=="code")
                    value=value.toLowerCase();
                    this.loading=true;
                    var query;
                    query=fb.db.collection("schools/"+this.schoolId+"/categories").where(this.searchField, "==", value);
                    // if(this.schools!=null){
                    //     query=query.where('school', "in", this.schools)
                    // }

                    if(query!=null){
                        var documentSnapshots=await query.get();
                        documentSnapshots.forEach(doc=> {
                            let object=doc.data();
                            object.id = doc.id;
                            this.teachers.push(object);
                        });

                    }
                    this.loading=false;

            },
            toggleDepartmentFilter(department, list, prop, search, limit){
                if(this.isInDepartmentFilter(department, list, prop)==true){
                    if(prop)
                        this.removeFromDepartmentFilter(department, list, prop);
                    else 
                        this.removeFromDepartmentFilter(department, list);
                }
                else{
                    if(limit && limit>0){
                        if(list.length>=limit){
                            list.splice(0,1);
                        }
                    }
                    else{
                        if(list.length>=10){
                            list.splice(0, 1);    
                        }
                    }
                    if(prop)
                        list.push(department[prop]);
                    else
                        list.push(department.index);
                }
                if(search && search==true)
                    this.search();
            },
            isInDepartmentFilter(department, list, prop){
                var exists=false;
                for(const current of list){
                    if(prop){
                        if(current && current==department[prop]){
                            exists=true;
                            break;
                        }
                    }
                    else
                        if(current && current==department.index){
                            exists=true;
                            break;
                        }
                }
                return exists;
            },
            removeFromDepartmentFilter(department, list, prop){
                var exists=false;
                var index=0;
                var i=0;
                for(const current of list){
                    if(prop){
                        if(current && current==department[prop]){
                            exists=true;
                            index=i;
                            break;
                        }
                    }
                    else 
                        if(current && current==department.index){
                            exists=true;
                            index=i;
                            break;
                        }
                    i++;
                }
                if(exists && exists==true){
                    list.splice(index, 1);
                }
            },
            async check(){
                var lessonSnapshot=await fb.db.collection("schools/"+this.schoolId+"/lessons").get();
                // for(const lessonDoc of lessonSnapshot.docs){
                //     if(lessonDoc.exists && lessonDoc.data().groups && lessonDoc.data().groups){
                //         for(const groupData of lessonDoc.data().groups){
                //             if(groupData){
                //                 var updateObject={};
                //                 if(groupData.program && groupData.program.id){
                //                     updateObject.programIds=fb.firestore.FieldValue.arrayUnion(groupData.program.id);
                //                     updateObject.programs=fb.firestore.FieldValue.arrayUnion(groupData.program);
                //                 }
                //                 if(groupData.departmentName){
                //                     var indexNo=parseInt(groupData.departmentName);
                //                     updateObject.classNos=fb.firestore.FieldValue.arrayUnion(indexNo);
                //                 }
                //                 if(groupData.department){
                //                     updateObject.departments=fb.firestore.FieldValue.arrayUnion(groupData.department);
                //                 }
                //                 await lessonDoc.ref.update(updateObject);
                //             }
                //         }
                //     }
                // }
                for(const lessonDoc of lessonSnapshot.docs){
                    if(lessonDoc.exists){
                        var tags=[];
                        if(lessonDoc.data().name){
                            tags.push(this.capitalize(lessonDoc.data().name));
                            tags.push(lessonDoc.data().name);
                            tags.push(lessonDoc.data().name.toLowerCase());
                            var arr=lessonDoc.data().name.split(" ");
                            if(arr && arr.length>0){
                                for(const word of arr){
                                    tags.push(this.capitalize(word));
                                    tags.push(word);
                                    tags.push(word.toLowerCase());
                                }
                            }
                        }
                        if(lessonDoc.data().teachers && lessonDoc.data().teachers.length>0){
                            for(const teacher of lessonDoc.data().teachers){
                                if(teacher){
                                    if(teacher.firstName){
                                        tags.push(this.capitalize(teacher.firstName));
                                        tags.push(teacher.firstName);
                                        tags.push(teacher.firstName.toLowerCase());
                                    }
                                    if(teacher.lastName){
                                        tags.push(this.capitalize(teacher.lastName));
                                        tags.push(teacher.lastName);
                                        tags.push(teacher.lastName.toLowerCase());
                                    }
                                }
                            }
                        }
                        if(tags && tags.length>0){
                            lessonDoc.ref.update({searchTags: tags});
                        }
                        
                    }
                }
                console.log("DONE");
            },
            capitalize(s)
            {   
                if(s && s!='')
                    return s && s[0].toUpperCase() + s.slice(1);
                return null;
            },
            programInLesson(lessons, program){
                if(lessons && lessons.length>0){
                    var exists=false;
                    for(const lesson of lessons){
                        if(lesson && lesson.id && lesson.programs && lesson.programs.length>0 && program && program.id){
                            for(const programRef of lesson.programs){
                                if(programRef && programRef.id && programRef.id==program.id){
                                    exists=true;
                                    break;
                                }
                            }
                        }
                    }
                    return exists;
                }
                return false;
            },
            async addTeacher(lesson, category){
                if(category){
                    if(lesson && lesson.teachers && lesson.teachers.length>0){
                        var teacher=lesson.teachers[0];
                        teacher.id=teacher.reference.id;
                        if(!category.teachers)
                            category.teachers=[];
                        var exists=false;
                        var foundIndex=0;
                        var index=0;
                        for(const currentteacher of category.teachers){

                            if(currentteacher && currentteacher.id && currentteacher.id==teacher.id){
                                exists=true;
                                foundIndex=index;
                                break;
                            }
                            index++;
                        }

                        if(exists==true){
                            // var teacherIt
                            var item=category.teachers[foundIndex];
                            if(!item.lessons)
                                item.lessons=[];
                            item.lessons.push(lesson);

                            
                        }
                        else{
                            
                            let item=lesson.teachers[0];
                            item.lessons=[];
                            item.lessons.push(lesson);
                            category.teachers.push(item);
                        }
                    }
                }
            },
            openSubContentModal(){
                $('#submodal').modal('show');

            },
            
  
        },
        created() {

            this.teachers=[];
            this._getData();
            // this.check();
                
        },

        filters: {
            formatDate(val) {
                if (!val) { return '-' }
                let date = val.toDate()
                return moment(date).fromNow()
            },
            trimLength(val) {
                if (val.length < 200) { return val }
                return `${val.substring(0, 200)}...`
            }
        }
    }
</script>
<style>
table#crossword tr:first-child td, th {
  border-top: 2px solid black;
}
table#crossword tr:last-child td, th {
  border-bottom: 2px solid black;
}
table#crossword tr td:first-child {
  border-left: 2px solid black;
}
table#crossword tr td:last-child {
  border-right: 2px solid black;
}
table#crossword tr:first-child th {
  border-top: 2px solid black;
}
table#crossword tr:last-child th {
  border-bottom: 2px solid black;
}
table#crossword tr th:first-child {
  border-left: 2px solid black;
}
table#crossword tr th:last-child {
  border-right: 2px solid black;
}
.left-border {
  border-left: 2px solid black!important;
}
.right-border {
  border-right: 2px solid black!important;
}
.border-top {
  border-top: 2px solid black!important;
}
.bottom-border {
  border-bottom: 2px solid black!important;
}
</style>